<template>
  <div class="pta-flag" :class="{ 'pta-flag--passed': hasPassed }">
    <div class="pta-flag__check">
      <CheckIcon />
    </div>
    <div class="pta-flag__question">
      {{ flag.name }}
    </div>
    <div class="pta-flag__answer">
      <input
        v-if="!hasPassed && canSubmit"
        @keyup.enter="sendAnswer"
        @input="showError = false"
        class="ine-input pta-flag__answer-input"
        :class="{ 'ine-input--error': showError }"
        v-model="userAnswer"
        placeholder="Your answer"
        :disabled="loadingAnswer"
      />
      <span class="pta-flag__answer-disabled" v-if="!hasPassed && !canSubmit">
        Please start the lab to submit flags
      </span>
      <span class="pta-flag__captured-pill" v-if="hasPassed">
        Flag captured
      </span>
      <div
        class="pta-flag__submit"
        @click="sendAnswer"
        v-if="!hasPassed && !loadingAnswer && !showError && canSubmit"
      >
        <ArrowRightIcon class="pta-flag__submit-icon" />
      </div>
      <div class="pta-flag__loading" v-if="!hasPassed && loadingAnswer">
        <LoadingSmallSpinner />
      </div>
      <div
        class="pta-flag__error"
        v-if="showError && canSubmit"
        @click="clearAnswer"
      >
        <XCircleIcon />
      </div>
    </div>
  </div>
</template>
<script>
import { CheckIcon, ArrowRightIcon, XCircleIcon } from 'vue-feather-icons'
import LoadingSmallSpinner from '@/components/loaders/LoadingSmallSpinner.vue'

export default {
  name: 'PTAFlag',
  components: {
    CheckIcon,
    ArrowRightIcon,
    XCircleIcon,
    LoadingSmallSpinner,
  },
  props: {
    flag: {
      type: Object,
      required: true,
    },
    userFlagStatus: {
      type: Object,
      required: true,
    },
    canSubmit: {
      type: Boolean,
      required: true,
      default: () => {
        return false
      },
    },
    labsRequestPayload: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      userAnswer: '',
      loadingAnswer: false,
      showError: false,
    }
  },
  computed: {
    hasPassed() {
      return this.userFlagStatus?.has_passed
    },
  },
  methods: {
    async sendAnswer() {
      this.showError = false
      this.loadingAnswer = true
      await this.$store.dispatch('labs/sendPTAFlag', {
        flagId: this.flag.uuid,
        answer: this.userAnswer,
        ...this.labsRequestPayload,
      })
      this.loadingAnswer = false
      this.showError = !this.userFlagStatus.has_passed
    },
    clearAnswer() {
      this.showError = false
      this.userAnswer = ''
    },
  },
  mounted() {
    this.userAnswer = this.userFlagStatus.answer || ''
  },
}
</script>
<style lang="scss" scoped>
.pta-flag {
  $this: &;
  width: 100%;
  display: flex;
  align-content: center;
  align-items: center;
  margin-bottom: 10px;
  padding: 15px 10px;
  text-align: left;
  min-height: 75px;
  background: linear-gradient(
    104.99deg,
    rgba(62, 63, 73, 0.7) -13.91%,
    rgba(62, 63, 73, 0) 100.48%
  );
  border-radius: 5px;
  &__check {
    line-height: 0;
    svg {
      stroke: var(--tundora-gray);
    }
  }
  &__question {
    width: 45%;
    font-size: 14px;
    line-height: 20px;
    padding: 0 15px;
  }
  &__answer {
    flex: 1;
    position: relative;
    text-align: right;
    &-input {
      width: 100%;
      &:focus + .pta-flag__submit svg {
        stroke: var(--light-blue-gray);
      }
    }
  }
  &__submit {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0, -50%);
    line-height: 0;
    cursor: pointer;
    svg {
      stroke: var(--tundora-gray);
      transition: all ease 0.5s;
    }
    &:hover {
      svg {
        stroke: var(--white) !important;
      }
    }
  }
  &__loading,
  &__error {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0, -50%);
    line-height: 0;
  }
  &__error {
    cursor: pointer;
    svg {
      stroke: #ff5e5e;
    }
  }
  &__captured-pill {
    padding: 5px 8px;
    background: #70ffd4;
    box-shadow: 0px 0px 10px rgba(112, 255, 212, 0.5);
    border-radius: 30px;
    color: #1e1e1e;
    font-size: 12px;
  }
  &--passed {
    #{$this}__check {
      svg {
        stroke: #70ffd4;
      }
    }
  }
}
</style>
